import { Link } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import "../styles/NavBar.css";
import facebook from "../icons/facebook-square_blue.svg";
import instagram from "../icons/instagram-square.svg";
import hamburger from "../icons/hamburger-menu.svg";
import logo from "../images/BribieIslandPicnics_Logo_Blue.jpg";

export default function NavBar() {
  const [isMobileMenuActive, setIsMobileMenuActive] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const menuRef = useRef(null);

  const toggleMobileMenu = (e) => {
    e.stopPropagation();
    setIsMobileMenuActive((prevState) => !prevState);
  };

  // Close hamburger manu by click on page
  useEffect(() => {
    const handleClickOutside = (e) => {
      // If clicked outside the menu
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsMobileMenuActive(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Function to handle scroll event
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    // Attach the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav className={`navbar__head ${isScrolled ? "navbar__scroll" : ""}`}>
      <div className="navbar__container">
        {/* Logo */}
        <div className="navbar__logo">
          <Link to="/" aria-label="home">
            <img src={logo} alt="Bribie Island Picnics" />
          </Link>
        </div>

        {/* Main Menu */}
        <div className="navbar__main--menu">
          <ul className="navbar__main--menu-list">
            <li className="navbar__main--menu-item">
              <Link
                to="/"
                className="navbar__main--menu-link"
                aria-label="home"
              >
                Home
              </Link>
            </li>
            <li className="navbar__main--menu-item">
              <Link
                to="/couples"
                className="navbar__main--menu-link"
                aria-label="couples"
              >
                Couples
              </Link>
            </li>
            <li className="navbar__main--menu-item">
              <Link
                to="/groups"
                className="navbar__main--menu-link"
                aria-label="groups"
              >
                Groups
              </Link>
            </li>
            <li className="navbar__main--menu-item">
              <Link
                to="/proposals"
                className="navbar__main--menu-link"
                aria-label="proposals"
              >
                Proposals
              </Link>
            </li>
            <li className="navbar__main--menu-item">
              <Link
                to="/special-events"
                className="navbar__main--menu-link"
                aria-label="event styling"
              >
                Event Styling
              </Link>
            </li>
            <li className="navbar__main--menu-item">
              <Link
                to="/booking"
                className="navbar__main--menu-link"
                aria-label="bookings"
              >
                Bookings
              </Link>
            </li>
            {/* Socials */}
            <li className="navbar__main--menu-item">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/bribiepicnics/"
                className="navbar__main-menu-link-icon"
                aria-label="Facebook"
              >
                <img className="sm_icon" src={facebook} alt="facebook" />
              </a>
            </li>
            <li className="navbar__main--menu-item">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.instagram.com/bribieislandpicnics/?hl=en"
                className="navbar__main-menu-link-icon"
                aria-label="Instagram"
              >
                <img className="sm_icon" src={instagram} alt="instagram" />
              </a>
            </li>
          </ul>
        </div>

        {/* Mobile Menu */}
        <div className="navbar__mobile--menu">
          {/* Hamburger Button */}
          <div
            className="navbar__mobile--menu-toggle"
            onClick={toggleMobileMenu}
          >
            <img
              className="navbar__mobile--menu-icon"
              src={hamburger}
              alt="menu"
              aria-label="navigation buttons"
            />
          </div>

          <div
            ref={menuRef}
            className={`navbar__mobile--menu-items ${
              isMobileMenuActive ? "active" : ""
            }`}
          >
            <ul className="navbar__mobile--menu-list">
              <li className="navbar__mobile--menu-item">
                <Link
                  to="/"
                  className="navbar__mobile--menu-link"
                  onClick={toggleMobileMenu}
                  aria-label="home"
                >
                  Home
                </Link>
              </li>
              <li className="navbar__mobile--menu-item">
                <Link
                  to="/couples"
                  className="navbar__mobile--menu-link"
                  onClick={toggleMobileMenu}
                  aria-label="couples"
                >
                  Couples
                </Link>
              </li>
              <li className="navbar__mobile--menu-item">
                <Link
                  to="/groups"
                  className="navbar__mobile--menu-link"
                  onClick={toggleMobileMenu}
                  aria-label="groups"
                >
                  Groups
                </Link>
              </li>
              <li className="navbar__mobile-menu-item">
                <Link
                  to="/proposals"
                  className="navbar__mobile--menu-link"
                  onClick={toggleMobileMenu}
                  aria-label="proposals"
                >
                  Proposals
                </Link>
              </li>
              <li className="navbar__mobile-menu-item">
                <Link
                  to="/special-events"
                  className="navbar__mobile--menu-link"
                  onClick={toggleMobileMenu}
                  aria-label="event styling"
                >
                  Event Styling
                </Link>
              </li>
              <li className="navbar__mobile--menu-item">
                <Link
                  to="/booking"
                  className="navbar__mobile--menu-link"
                  onClick={toggleMobileMenu}
                  aria-label="bookings"
                >
                  Bookings
                </Link>
              </li>
              {/* Socials */}
              <li className="navbar__mobile--menu-item">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/bribiepicnics/"
                  className="navbar__mobile-menu-link-icon"
                  onClick={toggleMobileMenu}
                  aria-label="facebook"
                >
                  <img className="sm_icon" src={facebook} alt="facebook" />
                </a>
              </li>
              <li className="navbar__mobile--menu-item">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/bribieislandpicnics/?hl=en"
                  className="navbar__mobile-menu-link-icon"
                  onClick={toggleMobileMenu}
                  aria-label="instagram"
                >
                  <img className="sm_icon" src={instagram} alt="instagram" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}
